function getGuidSection() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

export function guidGenerator() {
    return (
        getGuidSection() +
        getGuidSection() +
        '-' +
        getGuidSection() +
        '-' +
        getGuidSection() +
        '-' +
        getGuidSection() +
        '-' +
        getGuidSection() +
        getGuidSection() +
        getGuidSection()
    );
}
